module.exports = __webpack_public_path__ + "0711aa757ba879232130807ee5b5b109.png";